<template>
  <div class="tpass-warp tpReceiptDetail tpassDetail">
    <loading :show="apiLoading" :isTpass="true"></loading>
    <t-pass-header
      :title="'收據明細'"
      :routerUrl="backPageUrlName"
      :isRecord="isRecord"
      :receiptToken="receiptToken"
    ></t-pass-header>
    <div class="receipt-card bg-white">
      <div class="receipt-card-header">
        <t-pass-icon-point :isChangeIconWidth="true" ref="tPassIconPoint"></t-pass-icon-point>
        <div v-if="isConsole" class="console">
          <div>Path === {{ this.$route.fullPath }}</div>
          <div>$route.params === {{ $route.params }}</div>
          <div>$route.query === {{ $route.query }}</div>
          <div>pdfNym==={{ detailData[0].pdfNym }}</div>
          <div>有觸發下載 {{ test }}</div>
          <div>this.resData===={{ resData }}</div>
        </div>
      </div>
      <div class="order-bg">
        <div class="left-circle"></div>
        <div class="right-circle"></div>
        <div class="order-line"></div>
      </div>
      <div class="receipt-card-content">
        <!-- 收據明細 -->
        <t-pass-receipt-detail-content
          :TPassdetailData="detailData[0]"
        ></t-pass-receipt-detail-content>
      </div>
      <div class="bill-border"></div>
    </div>
    <div class="receipt-footer bg-white" v-if="!isMarkHold">
      <b-button :variant="'primary-2'" :class="'tp-col-12'" @click="goConfirmation()"
        >歸戶</b-button
      >
    </div>

    <b-modal
      id="modal-msg"
      ref="modal-msg"
      header-class="justify-content-center"
      footer-class="justify-content-center"
      no-close-on-esc
      no-close-on-backdrop
      centered
      :hide-header-close="true"
      :hide-header="true"
    >
      <t-pass-icon-point ref="msgPoint"></t-pass-icon-point>
      <template v-slot:modal-footer="{}" :class="'selectBox'">
        <div class="text-center">
          <b-button variant="select" class="col-12 confirm" @click="close()">
            <div>確認</div>
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import CommonApiMixin from '@/mixins/commonApi';
import ApiMixin from '@/mixins/api';

export default {
  name: 'TpassReceiptDetail',

  mixins: [CommonApiMixin, ApiMixin],

  data() {
    return {
      detailData: [
        {
          rpStatus: '1',
          rpDownloadCount: 0,
          isMarkHold: true,
          piName: '',
          rpPublicNo: '',
          rpArAmt: '',
          rpDicountAmt: '',
          rpRealAmt: '',
          ogName: '',
          rpOpenDate: '',
          rpDate: '',
          rpPayManName: '',
          pmName: '',
          rpIsStampDuty: '',
          rpIsPreOpen: '',
          rpOperatorName: '',
          rpCashierName: '',
          rpRemark: '',
        },
      ],
      reqData: {
        rpPublicNo: '',
        rpPublicRandomCode: '',
      },
      apiLoading: false,
      isRecord: false,
      receiptToken: '', // QRCode歸戶token
      receiptInductionResData: {},
      resData: '',
      test: '',
      isConsole: false,
      isMarkHold: true,
      isNotReceipt: false,
      backPageUrlName: 'taipeiPassAppReceiptReturnHome',
    };
  },

  created() {
    console.log('this.$route-', this.$route);
    if (JSON.stringify(this.$route.query) !== '{}') {
      this.setResData('query');
    } else if (JSON.stringify(this.$route.params) !== '{}') {
      this.setResData('params');
      this.isRecord = this.$route.params.isRecord;
    }

    if (this.reqData.rpPublicNo && this.reqData.rpPublicRandomCode) {
      this.QrgetData(this.reqData);
    } else {
      this.viewClose();
    }

    if (this.isRecord) {
      this.backPageUrlName = 'taipeiPassAppReceiptRecord';
    } else {
      this.backPageUrlName = 'taipeiPassAppReceiptReturnHome';
    }
  },

  methods: {
    viewClose() {
      window.location = `viewclose://`;
    },
    setResData(key) {
      const route = this.$route[key];
      this.reqData = {
        rpPublicNo: route.rpPublicNo,
        rpPublicRandomCode: route.rpPublicRandomCode,
      };
      this.receiptToken = route.receiptToken;
    },

    goConfirmation() {
      this.apiLoading = true;
      this.reqData.receiptToken = this.receiptToken;
      const url = '/GovEReceipt/tpassService/receiptInduction';
      const method = 'post';
      this.axiosServiceSend(this.reqData, url, method, 'receiptInduction');
    },
    QrgetData(data) {
      this.apiLoading = true;
      const url = '/GovEReceipt/FrontDeskService/QueryFNTSF';
      const method = 'post';
      this.axiosServiceSend(data, url, method, 'QrgetData');
    },

    // 下載次數
    downloadCount() {
      this.apiLoading = true;
      const pdfnym = this.detailData[0].pdfNym;
      const url = `/GovEReceipt/PdfService/downloadPdf${!pdfnym ? '' : `/${pdfnym}`}`;

      const other = {
        responseType: 'blob',
      };
      this.axiosServiceSend({}, url, 'post', 'downloadCount', other);
    },
    downloadTimes() {
      const data = {
        rpId: this.detailData[0].rpId,
        rpDownloadCount: this.detailData[0].rpDownloadCount,
      };
      this.axiosServiceSend(data, '/GovEReceipt/ReceiptService/count', 'post', 'downloadTimes');
    },

    success(type, result) {
      let blob = result.data;
      let iconPointType = '';
      const reader = new FileReader();
      switch (type) {
        case 'QrgetData':
          console.log('QrgetData', result);
          setTimeout(() => {
            this.apiLoading = false;
          }, 100);
          if (result.data.object.length > 0) {
            this.detailData = result.data.object;
            this.isMarkHold = this.detailData[0].isMarkHold;
            if (this.detailData[0].rpStatus === '1') {
              iconPointType = 'success';
            } else {
              iconPointType = 'warning';
            }
            this.$refs.tPassIconPoint.changeMsgIcon(iconPointType, this.detailData[0].rpStatusName);
          } else {
            this.notReceiptMsgModel();
          }

          break;
        case 'receiptInduction':
          setTimeout(() => {
            this.apiLoading = false;
          }, 100);
          console.log('result.data.object', result.data.object);
          this.receiptInductionResData = result.data.object;
          if (JSON.stringify(result.data.object) !== '{}') {
            this.$router.push({
              name: 'taipeiPassAppReceiptConfirmation',
              params: {
                receiptInductData: this.receiptInductionResData,
                receiptToken: this.receiptToken,
                isRecord: this.isRecord,
              },
            });
          }
          break;
        case 'downloadCount':
          // safari application/pdf不吃 改用 .* 萬用類型 : application/octet-stream
          blob = blob.slice(0, blob.size, 'application/octet-stream');
          reader.readAsDataURL(blob);
          this.resData = result.data.size;
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // this.test = 'downloadCount API 1---觸發';
            window.navigator.msSaveBlob(blob, `${this.detailData[0].rpPublicNo}.pdf`);
          } else {
            // this.test = 'downloadCount API 2---觸發';
            reader.onload = (e) => {
              const a = document.createElement('a');
              a.download = `${this.detailData[0].rpPublicNo}.pdf`;
              a.href = e.target.result;
              // a.target = '_blank';
              document.body.appendChild(a);

              a.click();
              document.body.removeChild(a);
            };

            // window.open('http://www.google.com.tw/', '_blank', 'download');
          }
          if (result.data) {
            this.downloadTimes();
          }
          setTimeout(() => {
            this.apiLoading = false;
          }, 100);
          break;
        case 'downloadTimes':
          this.detailData[0].rpDownloadCount += 1;
          console.log('下載次數:', this.detailData[0].rpDownloadCount);
          // this.test = 'downloadTimes 下載次數 API---觸發';
          break;
        default:
          break;
      }
    },
    fail(type, error) {
      switch (type) {
        case 'QrgetData':
          console.log(error);
          this.notReceiptMsgModel();
          break;
        case 'downloadCount':
          console.log(error);
          this.showApiMessage('error', '查無此檔案', '下載檔案失敗');
          break;
        default:
          break;
      }
      this.apiLoading = false;
    },

    notReceiptMsgModel() {
      this.$bvModal.show('modal-msg');
      this.isNotReceipt = true;
      this.$nextTick(() => {
        this.$refs.msgPoint.changeMsgIcon('ERROR', '提醒', '查無此收據', '');
      });
    },
    close() {
      console.log('--關閉--');
      if (this.isNotReceipt) {
        this.$router.push({
          name: this.backPageUrlName,
          params: {
            isRecord: this.isRecord,
          },
        });
      } else {
        this.$bvModal.hide('modal-msg');
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
